export enum GeneralActionType {
  SET_IS_ALLOW_COOKIES = 'SET_IS_ALLOW_COOKIES'
}

export const onAllowCookies = (isAllow: boolean) => (dispatch: any) => {
  dispatch({type: GeneralActionType.SET_IS_ALLOW_COOKIES, isAllow});
};
